define('home/templates/channelPromotion',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<img src=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.channel : depth0)) != null ? stack1.options : stack1)) != null ? stack1.tile : stack1), depth0))
    + "\" class=\"tile__media\" />\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"tile__overlay\">\n<h1 class=\"tile__name\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.channel : depth0)) != null ? stack1.name : stack1), depth0))
    + "</h1>\n</div>\n<img src=\"https://media.disquscdn.com/home/blank_tile.png\"\nclass=\"tile__media\" />\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return "<div class=\"channels-module__inner\">\n<a href=\"/home/channel/"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.channel : depth0)) != null ? stack1.slug : stack1), depth0))
    + "/\" class=\"tile__wrapper\">\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = ((stack1 = (depth0 != null ? depth0.channel : depth0)) != null ? stack1.options : stack1)) != null ? stack1.tile : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "</a>\n<div class=\"channels-description\">\n<p>"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.channel : depth0)) != null ? stack1.options : stack1)) != null ? stack1.description : stack1), depth0))
    + "</p>\n</div>\n<div class=\"channels-metadata\">\n<div class=\"padding-gutter align align--middle\" data-role=\"stats\">\n"
    + ((stack1 = container.invokePartial(partials.channelMetadataStats,depth0,{"name":"channelMetadataStats","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n</div>\n<div class=\"padding-gutter border-top hidden-lg\">\n<h4 class=\"text-subheading spacing-bottom\">"
    + alias2(helpers.gettext.call(alias3,"Recommended Discussions",{"name":"gettext","hash":{},"data":data}))
    + "</h4>\n<section data-role=\"discussions\" class=\"channels-module__discussions\"></section>\n</div>\n</div>\n";
},"usePartial":true,"useData":true})

});
